module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-get-started@2x.b552c165.png";